<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="done"></progress-components>
      <div v-if="prescription === '有'">
        <div class="mx-10 my-10">
          <v-row no-gutters justify="center" class="mx-5">
            <v-col>
              <v-card class="pa-3" color="doorMainColor" tile><span class="text-white font-weight-bold">診察ID</span></v-card>
            </v-col>
            <v-col>
              <v-card elevation="0" class="pa-3" outlined tile>{{ treatmentSerialNumber }}</v-card>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" class="mx-5" >
            <v-col>
              <v-card color="doorMainColor" elevation="0" class="pa-3" tile>
                <span class="text-white font-weight-bold">患者氏名</span>
              </v-card>
            </v-col>
            <v-col>
              <v-card elevation="1" class="pa-3" tile>{{ name }}</v-card>
            </v-col>
          </v-row>
          <v-row class="my-6">
            <div>1. 以下の処方箋ボタンを押下してください。</div>
            <div>2. 上記診療ID、氏名をコピペして「登録」ボタンを押下して処方箋登録をお願いします。</div>
          </v-row>
          <v-row justify="center" align-content="center" class="my-10">
            <v-btn
              dark
              x-large min-width="200px"
              color="success"
              class="mb-4 mx-4"
              @click="clickedPrescription"
            >処方箋
            </v-btn>
          </v-row>
        </div>
      </div>
      <v-row v-else justify="center" class="mb-8 my-6">
        <div class="text-body-1" style="font-weight: bold;">診察記録を登録しました。</div>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { Logger } from 'aws-amplify'
import { useRouter } from 'vue-router'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/MedicalRecordTitle.vue'
import ProgressComponents from '@/components/MedicalRecordProgress.vue'
import { useScreenOperation } from '@/func/useScreenOperation'

const logger = new Logger('AdvanceForm');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents
  },
  setup() {
    const { scrollToTop, fromConfirmScreen } = useScreenOperation()
    const fromConfirm = computed(() => fromConfirmScreen())

    logger.info('MedicalRecord Done')
    scrollToTop()

    const store = useStore()
    const name = computed(() => store.getters['advanceInterview/name'])
    const treatmentSerialNumber = computed(() => store.getters['apiParams/treatmentSerialNumber'])
    const prescription = computed(() => store.getters['medicalRecord/prescription'])

    const prescriptionUrl = ref(process.env.VUE_APP_TOKYO_PRESCRIPTION)
    const clickedPrescription = () => {
      open(prescriptionUrl.value, '_blank')
    }

    const router = useRouter()
    const toBack = () => router.go(-1)

    const clickedSubmit = () => {
      router.push('/record/done')
    }
    return {
      fromConfirm,
      clickedSubmit,
      toBack,
      prescription,
      clickedPrescription,
      name,
      treatmentSerialNumber
    }
  }
})
</script>
